import {
    GET_ALL_PRODUCTS_SUCCESS,
    GET_RECOMMENDED_RESULTS_SUCCESS,
    RESET_QUESTIONNAIRE,
} from '../../constants';

const initialResultsState = {
    recommendedResultsLoaded: false,
    allProductsLoaded: false,
    recommendedResults: [],
    allProducts: [],
};

export default function resultsReducer(
    state = initialResultsState,
    action,
) {
    switch (action.type) {
        case RESET_QUESTIONNAIRE:
            return initialResultsState;
        case GET_RECOMMENDED_RESULTS_SUCCESS: {
            return {
                ...state,
                recommendedResultsLoaded: true,
                recommendedResults: action.recommendedResults,
            };
        }
        case GET_ALL_PRODUCTS_SUCCESS: {
            return {
                ...state,
                allProductsLoaded: true,
                allProducts: action.allProducts,
            };
        }
        default:
            return state;
    }
}
